import React, { useState, useEffect } from 'react';
import OneFollowee from '../Followee/OneFollowee';
import { style } from '../../utils/image';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';
// import AllForBigPicPersonList from '../BigPic/AllForBigPicPersonList';
import wxUtil from '../../utils/wx';
import usePerson from '../Followee/usePerson';
import './AllForPeopleList.scss';
const { getTitle, getShareUrl } = wxUtil;

interface IAllForPeopleList {
  personList: any[];
  rootStore?: RootStore;
}

const AllForPeopleList = function(props: IAllForPeopleList) {
  const [personid, setPersonid] = useState('');
  const [imageid, setImageid] = useState(''); // 当前点击的imageid

  const { relationStore, galleryStore, wxuserStore } = props.rootStore!;

  useEffect(() => {
    if (relationStore.person && relationStore.person.id) {
      let oldLink = window.location.href;
      wxUtil.configPersonShare(relationStore.person.id);

      return () => {
        window.history.replaceState('person', window.document.title, oldLink);
        // 设置分享
        let { prefix, url_labeling, name } = window.gallery;
        let {
          h5_share_title,
          h5_share_image,
          h5_share_text
        } = window.configDetail;

        if (
          window.pageDetail.h5_share_title &&
          window.pageDetail.h5_share_image &&
          window.pageDetail.h5_share_text
        ) {
          h5_share_title = window.pageDetail.h5_share_title;
          h5_share_text = window.pageDetail.h5_share_text;
          h5_share_image = window.pageDetail.h5_share_image;
        }

        wxUtil.configShare({
          title: getTitle(),
          image:
            'http://' +
            (window.configDetail.use_global * 1 ? 'iglobal1' : 'image1') +
            window.__basename +
            '/' +
            h5_share_image,
          url: getShareUrl(),
          desc: h5_share_text
        });
      };
    }
  }, [relationStore.person && relationStore.person.id]);

  const clickPerson = function(personid: number, imageid: number, faceurl?:string) {
    console.log('click person', personid, imageid);

    let galleryid =
      (window.dataDetail ? window.dataDetail!.id : window.gallery.id) + '';

    usePerson(relationStore, personid, imageid, galleryid, faceurl);
  };

  const unfollow = () => {
    let { person } = relationStore;

    wxuserStore.unfollow(person.id).then(() => {
      relationStore.follower();
      setPersonid('');
    });
  };

  const follow = () => {
    let { person } = relationStore;
    let params = {
      image: person.faceurl,
      name: person.name,
      personid: person.id
    };

    wxuserStore.follow(params).then(() => {
      relationStore.follower();
    });
  };

  return (
    <div className="all-for-people-list">
      <div className="real-list">
        {props.personList.map((it: any, index) => {
          const faceurl = style(
            it.image.hash,
            'face',
            {
              shape: typeof it.shape == 'string' ? JSON.parse(it.shape) : it.shape
            },
            index
          );
          const originShapeUrl = style(
            it.image.hash,
            'face',
            {
              shape: typeof it.shape == 'string' ? JSON.parse(it.shape) : it.shape,
              noShapeScale:true
            },
            index
          );
          return (
            <OneFollowee
              key={it.id}
              // 务必传入最后一个参数给image.url.否则因为生成的ID在变动，渲染上会出现重新加载图片的问题
              src={faceurl}
              onClick={clickPerson.bind(null, it.personid, it.imageid, originShapeUrl)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(AllForPeopleList));
